import { Spin } from "antd-v5";
import ACComment from "components/ACComment";
import { useGlobalUserListContext } from "contexts/GlobalUserListContext";
import { marked } from "marked";
import React, { useEffect, useMemo, useRef, useState } from "react";
import FindingAPI from "restAPI/FindingAPI";
import { CommentResponse } from "types/comment";
import { convertCommentToNewFormat } from "views/Findings/FindingDetails/common";

import ACLink from "ac-components/ACLink/ACLink";
import { NOT_AVAILABLE } from "ac-components/ac-na-component/ac-na-component";

import "./FindingCommentsCell.less";

interface CommentsOverlayProps {
  findingId: number;
  onViewFinding?: () => void;
}

export default function CommentsOverlay({
  findingId,
  onViewFinding,
}: CommentsOverlayProps) {
  const [comments, setComments] = useState<CommentResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const cancelRef = useRef<() => void>();
  const { getAllUsersList } = useGlobalUserListContext();
  const userList = useMemo(getAllUsersList, [getAllUsersList]);

  useEffect(() => {
    setLoading(true);
    const { promise, cancel } = FindingAPI.getComments(findingId, {
      page: 0,
      size: 3,
    });
    cancelRef.current = cancel;

    promise
      .then((response: { content: CommentResponse[] }) => {
        setComments(
          (response.content || []).map((data) => ({
            ...data,
            comment: marked.parse(
              convertCommentToNewFormat(data.comment),
            ) as string,
          })),
        );
      })
      .catch(() => setComments([]))
      .finally(() => setLoading(false));

    return () => cancelRef.current?.();
  }, [findingId]);

  if (loading) {
    return (
      <div className="comments-overlay__loading">
        <Spin size="small" />
      </div>
    );
  }

  if (!comments.length) {
    return <div className="comments-overlay__empty">{NOT_AVAILABLE}</div>;
  }

  return (
    <div className="comments-overlay">
      <ACComment
        commentList={comments}
        showEditButton={false}
        users={userList}
      />
      {onViewFinding && (
        <div className="comments-overlay__footer">
          <ACLink primary={false} onClick={onViewFinding}>
            View finding to view all comments
          </ACLink>
        </div>
      )}
    </div>
  );
}
